module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/categories/massage-1ed8a24b7c3bb5a9f7948e13336715ff.png";